// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
export class DirectXMLMessage extends DirectMessageBaseClass {
    constructor(code) {
        super(code);
        this.XMLText = null;
    }
}
